import React, {useState} from 'react'
import Page from 'organization/Event/TemplateEditor/Page'
import Login from 'Event/auth/Login'
import {DesignBreadcrumbs} from 'organization/Event/Page/PageBreadcrumbs'
import LanguageSelector from 'organization/Event/LocalizationConfig/LanguageSelector'
import {useEvent} from 'Event/EventProvider'
import {ObvioEvent} from 'Event'
import {getEventUrl} from 'lib/url'
import styled from 'styled-components'
import {eventRoutes} from 'Event/Routes'
import FileCopyIcon from '@material-ui/icons/FileCopy'
import Button from 'lib/ui/Button'

export default function LoginConfig() {
  const {event} = useEvent()

  return (
    <DesignBreadcrumbs page="Login">
      <Page
        toolbarItems={
          <>
            <LanguageSelector />
            <LoginUrl event={event} show />
          </>
        }
      >
        <Login isPreview />
      </Page>
    </DesignBreadcrumbs>
  )
}

function LoginUrl(props: {event: ObvioEvent; show: boolean}) {
  const {event, show} = props
  const [copied, setCopied] = useState(false)

  if (!show) return null

  const eventUrl = getEventUrl(event)
  const loginUrl = eventRoutes.login

  const url = `${eventUrl}${loginUrl}`

  const handleCopyClick = () => {
    navigator.clipboard.writeText(url)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  return (
    <LoginUrlWrapper>
      {copied && <CopiedText>Copied!</CopiedText>}
      <CopyUrlButton
        variant="outlined"
        color="primary"
        size="small"
        startIcon={<FileCopyIcon style={{fontSize: 14}} />}
        onClick={handleCopyClick}
        aria-label="Copy Login URL"
      >
        Copy Login URL
      </CopyUrlButton>
    </LoginUrlWrapper>
  )
}

const CopiedText = styled.span`
  font-size: 0.875rem;
  color: ${(props) => props.theme.colors.success};
  padding: 0 0.5rem;
  margin-right: 0.5rem;
`
const LoginUrlWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: 10px;
  position: absolute;
  right: 160px;
`
const CopyUrlButton = styled(Button)`
  && {
    color: ${(props) => props.theme.colors.primary};
  }
`
